import { apiClient } from '@/lib/api-client'
import type { Term, TermListResponse } from '@/types/terms'

/**
 * Fetch a whole collection in one request.
 *
 * The backend has no offset/cursor and `total` is just `len(terms)`, so paging
 * is not available. A collection is tens of thousands of rows (~3–5 MB raw,
 * ~10x smaller gzipped), small enough to hold client-side — and that is what
 * makes filtering instant instead of a round-trip per keystroke.
 */
export async function getTerms(collectionId: number | null): Promise<Term[]> {
  const { data } = await apiClient.get<TermListResponse>('/terms', {
    params: { limit: 100000, search: '', lang: '', ...(collectionId ? { collection_id: collectionId } : {}) },
  })
  return data.terms ?? []
}
